import { ReactNode } from 'react';

const fixedInputClass =
  'rounded-md appearance-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 focus:outline-none focus:ring-purple-500 focus:border-purple-500 focus:z-10 sm:text-sm';

interface InputProps {
  handleChange: React.ChangeEventHandler<HTMLInputElement>;
  value: string;
  labelText: string;
  labelFor: string;
  id: string;
  name: string;
  type: string;
  isRequired: boolean;
  placeholder: string;
  customClass?: string;
  extra?: ReactNode;
  note?: string;
  tabIndex?: number;
}

export default function Input(props: InputProps) {
  return (
    <div
      className={`py-2 flex flex-col gap-2 ${
        props.type === 'hidden' ? 'hidden' : 'flex'
      }`}
    >
      <div className="flex flex-row gap-2">
        <label htmlFor={props.labelFor} className="text-sm font-medium grow">
          {props.labelText}
        </label>

        {props.extra}
      </div>
      <input
        onChange={props.handleChange}
        value={props.value}
        id={props.id}
        name={props.name}
        type={props.type}
        required={props.isRequired}
        className={`${fixedInputClass}${props.customClass ?? ''}`}
        placeholder={props.placeholder}
        tabIndex={props.tabIndex ?? undefined}
      />
      {props.note && <p className="text-sm text-gray-500 mb-2">{props.note}</p>}
    </div>
  );
}
